// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/internals/enum-bug-keys.js
// module id = 154
// module chunks = 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35